import { createAction, props } from '@ngrx/store';
import { Period } from '@shared/types/period';

export const setPreferredPeriod = createAction('[Cart] Set Preferred Period', props<{ period: Period | undefined }>());
